export default "__VITE_ASSET__BGI6$Zgs__"